<template>
  <modal id="confirmInvoiceWithoutPeppol" v-cloak>
    <template slot="title">Factuur voltooien</template>
    <div slot="body">
      Ben je zeker dat je deze factuur wil voltooien zonder naar peppol te versturen
    </div>
    <div slot="footer">
      <button class="btn-basic btn-outline-pulse-dark mr-2" @click="closeModal()">Annuleren</button>
      <button class="btn-basic btn-outline-pulse mr-2" @click="confirmInvoice()">Toch voltooien</button>
    </div>
  </modal>
</template>
<script>
import {VoerroModal} from "@voerro/vue-modal";
import {mapActions} from "vuex";

export default {
  name: "ConfirmInvoiceWithoutPeppolModal",
  methods: {
    ...mapActions("administrationInvoice", ["updateInvoiceStatus"]),
    closeModal() {
      VoerroModal.hide('confirmInvoiceWithoutPeppol');
    },
    confirmInvoice() {
      this.updateInvoiceStatus('CONFIRMED')
          .then(() => VoerroModal.hide('confirmInvoiceWithoutPeppol'));
    },
  }
};
</script>